import { ReactNode } from 'react';

export enum EPricingDealType {
  VENUE_HIRE = 'hire',
  PACKAGES_ALL = 'packagesall',
  PACKAGES_PP = 'packagespp',
  CATERING = 'catering',
}

export type PricingItem = {
  dealType: EPricingDealType;
  guests?: number;
  guestsInfo?: ReactNode;
  guestsLabel?: string;
  icon?: ReactNode;
  includedInPricing: string[];
  info?: string;
  initiallyExpanded: boolean;
  label: string;
  priceLabel?: string;
  labelInfo?: string;
  maxPrice: number;
  minPrice: number;
  onShowDetailsClick?: (label: string) => void;
  visible: boolean;
};
